module.exports = __webpack_public_path__ + "/images/ico-edit.02df3a1.svg";